export default "__VITE_ASSET__CXe28yCk__"